var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-rotator",
      class: { "image-rotator--with-descriptions": _vm.hasDescriptions },
      style: { height: _vm.imgHeight }
    },
    [
      _c(
        "button",
        {
          staticClass: "image-rotator__btn image-rotator__btn--prev",
          on: { click: _vm.prevImage }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 223 395.65"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "carousel",
        {
          style: { height: _vm.imgHeight },
          attrs: {
            "per-page": 1,
            "navigate-to": [_vm.shownImage, _vm.animate],
            "pagination-enabled": _vm.paginationEnabled
          },
          on: { pageChange: _vm.onPageChange }
        },
        _vm._l(_vm.shownSlides, function(slide, slideKey) {
          return _c(
            "slide",
            {
              key: slideKey,
              attrs: { "data-index": slideKey },
              on: { slideclick: _vm.onClick }
            },
            [
              _vm.thumbnail
                ? _c("div", {
                    staticClass: "image-rotator__img",
                    style: {
                      "background-image": _vm.getBackgroundImagetag(slide.image)
                    }
                  })
                : [
                    slide.description
                      ? _c("p", {
                          staticClass: "slide-description",
                          domProps: { textContent: _vm._s(slide.description) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    slide.type == "image"
                      ? _c("img", {
                          ref: "imgElements",
                          refInFor: true,
                          staticClass: "image-rotator__img",
                          attrs: { src: _vm.getImagetag(slide.image) },
                          on: { load: _vm.readImgHeight }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    slide.type == "video"
                      ? _c("div", { staticClass: "image-rotator__vid" }, [
                          _c("iframe", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: slide.url }
                          })
                        ])
                      : _vm._e()
                  ]
            ],
            2
          )
        })
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "image-rotator__btn image-rotator__btn--next",
          on: { click: _vm.nextImage }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 223 395.65"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.showHeliviewBtn
        ? _c(
            "button",
            {
              staticClass: "image-rotator__heliview-btn",
              on: {
                click: function($event) {
                  _vm.$emit("heliviewclick")
                }
              }
            },
            [
              _c("img", {
                staticClass: "image-rotator__heliview-icon",
                attrs: { src: require("./../../img/icons/icon-heliview.svg") }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c569998", { render: render, staticRenderFns: staticRenderFns })
  }
}